export enum QuestionType {
    Text = 0,
    TextDescription = 'Text',
    Number = 1,
    NumberDescription = 'Number',
    Checkbox = 2,
    CheckboxDescription = 'Multiple choice',
    Radiobutton = 3,
    RadiobuttonDescription = 'Single choice',
    Rating = 4,
    RatingDescription = 'Rating',
    MatrixCheckbox = 5,
    MatrixCheckboxDescription = 'Matrix choice checkboxes',
    MatrixRadiobutton = 6,
    MatrixRadiobuttonDescription = 'Matrix choice radiobuttons',
    SatisfactionRate = 7,
    SatisfactionRateDescription = 'Satisfaction rate',
}
